import { getDateFormatted } from '@shared/utils'
import { useTranslation } from 'react-i18next'

import './style.css'

export const SRBigCalendarEventMonth = ({ event = {} }) => {
  const { t } = useTranslation()
  const { start, end, originalStartDate, originalEndDate, effectiveStartDate, effectiveEndDate, appointmentType } = event

  if (!start || !appointmentType) return

  // Usar las fechas originales para mostrar el horario real de la cita
  const actualStart = originalStartDate || start
  const actualEnd = originalEndDate || end
  
  const startDate = getDateFormatted(actualStart, 'HH:mm')
  const endDate = getDateFormatted(actualEnd, 'HH:mm')
  
  // Verificar si hay tiempo efectivo antes y después (comparar con fechas reales de la cita)
  const hasEffectiveBefore = effectiveStartDate && effectiveStartDate.getTime() !== actualStart.getTime()
  const hasEffectiveAfter = effectiveEndDate && effectiveEndDate.getTime() !== actualEnd.getTime()
  
  const effectiveStartTime = effectiveStartDate ? getDateFormatted(effectiveStartDate, 'HH:mm') : null
  const effectiveEndTime = effectiveEndDate ? getDateFormatted(effectiveEndDate, 'HH:mm') : null

  return (
    <div className="pl-1 flex gap-1 items-center">
      <div
        className={`bg-${appointmentType.color}-base rounded-full w-[14px] h-[12px]`}
      />
      <div className="flex flex-col text-[10px] w-full">
        <div className="flex gap-1 items-center">
          {hasEffectiveBefore && (
            <span 
              className="text-[9px] px-1 py-0.5 rounded"
              style={{ 
                backgroundColor: '#577193',
                color: 'white',
                display: 'inline-block'
              }}
            >
              {effectiveStartTime}
            </span>
          )}
          <p>{startDate}-{endDate}</p>
          {hasEffectiveAfter && (
            <span 
              className="text-[9px] px-1 py-0.5 rounded"
              style={{ 
                backgroundColor: '#577193',
                color: 'white',
                display: 'inline-block'
              }}
            >
              {effectiveEndTime}
            </span>
          )}
        </div>
        <p className="eventName">{t(appointmentType.text)}</p>
      </div>
    </div>
  )
}
